import React, { Component } from 'react';
import FloatingFilter from '../components/atoms/FloatingFilter';
import TimeSpanFilter from '../components/atoms/TimeSpanFilter';
import SingleSetFilter from '../components/atoms/SingleSetFilter';

const columnTypes = {
    numberColumn: {
        filter: 'set',
        floatingFilterComponentFramework: FloatingFilter
    },
    editableColumn: { editable: true },
    dateColumn: {
        filter: 'date',
        filterParams: {
            comparator: function(filterLocalDateAtMidnight, cellValue) {
                var cellDate = new Date(cellValue);
                if (cellDate < filterLocalDateAtMidnight) {
                    return -1;
                } else if (cellDate > filterLocalDateAtMidnight) {
                    return 1;
                } else {
                    return 0;
                }
            }
        },
        valueFormatter: dateFormatter
    },
    stringColumn: {
        filter: 'set',
        floatingFilterComponentFramework: FloatingFilter
    },
    timeSpanColumn: {
        filter: null,
        floatingFilterComponentFramework: FloatingFilter,
        filterFramework: TimeSpanFilter,
        valueFormatter: dateFormatter
    },
    singleColumn: {
        filter: null,
        floatingFilterComponentFramework: FloatingFilter,
        filterFramework: SingleSetFilter
    }
};

function dateFormatter(params) {
    var options = {
        weekday: 'long',
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    };
    const date = new Date(params.value);
    if (date.toString() !== 'Invalid Date') {
        return new Date(params.value).toLocaleDateString('en-US', options);
    }
    return params.value;
}

function timeSpanComparator(filterLocalDateAtMidnight, cellValue) {
    var dateParts = cellValue.split('/');
    var day = Number(dateParts[2]);
    var month = Number(dateParts[1]) - 1;
    var year = Number(dateParts[0]);
    var cellDate = new Date(day, month, year);
    if (cellDate < filterLocalDateAtMidnight) {
        return -1;
    } else if (cellDate > filterLocalDateAtMidnight) {
        return 1;
    } else {
        return 0;
    }
}

module.exports = {
    columnTypes
};



// WEBPACK FOOTER //
// ./modules/columnTypes.js